import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/admin/agents")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/agents" });
	},
});
